export default __webpack_public_path__ + "static/media/new-pitch-tow.f5b24875.png";